/*
Copyright 2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

.controls {
  display: flex;
  gap: 15px;

  & > input {
    flex: 1;
    min-inline-size: 0;
  }
}

.button-group {
  display: flex;
  inset-block-start: var(--cpd-space-1x);
  align-items: center;
  gap: var(--cpd-space-2x);
}
